export default __webpack_public_path__ + "static/19-mohawk-skull-d052b60ec2d4db766e995f6183a9062a.png";